import { Component, type ErrorInfo, type ReactNode } from 'react';
import { clearSlice } from '../state/persistence';
import { Button } from './Button';

interface State {
  error: Error | null;
}

/** App-level safety net. Persistence means progress survives a reload. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('ClueVine crashed:', error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="cv-error-screen">
          <h1 className="cv-display">A leaf fell.</h1>
          <p className="cv-muted">Something went wrong — but your progress is safe.</p>
          <div className="cv-row cv-wrap" style={{ gap: 'var(--space-xs)', justifyContent: 'center' }}>
            <Button variant="primary" onClick={() => window.location.reload()}>
              Reload ClueVine
            </Button>
            <Button
              variant="ghost"
              onClick={() => {
                // If a saved puzzle is what keeps crashing, drop it (stats and streaks are kept).
                clearSlice('sessions');
                clearSlice('session');
                window.location.reload();
              }}
            >
              Reload without saved puzzles
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
